import React from 'react';

const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,.8A9.2,9.2,0,1,0,19.2,10,9.21,9.21,0,0,0,10,.8Z" />
    <path d="M14.89,7.47a1.12,1.12,0,0,0-.74-.27,1.14,1.14,0,0,0-.74.27L9,11.36,6.65,9.3A1.16,1.16,0,0,0,5.6,9a1,1,0,0,0-.77.67.88.88,0,0,0,.3.92l3,2.67a1,1,0,0,0,.37.21,1.14,1.14,0,0,0,1.18-.18l5.18-4.55a.88.88,0,0,0,.31-.66A.86.86,0,0,0,14.89,7.47Z" />
  </svg>
);

export default SuccessIcon;
